import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import './Redirect.scss';

export default function Redirect() {
  const navigate = useNavigate();
  const hostname = window.location.hostname;
  const isRedwoodSeed = hostname.includes('redwoodseed') || hostname.includes('redwoodvaluation') || hostname.includes('localhost');

  useEffect(() => {
    async function validateAndRedirect() {
      try {
        await fetchAuthSession(); // Validate session
        const portal = new URLSearchParams(window.location.search).get("portal");

        if (portal === 'enterprise') {
          // window.location.href = process.env.REACT_APP_ENTERPRISE_HOSTNAME;
          if(isRedwoodSeed) {
            window.location.href = process.env.REACT_APP_ENTERPRISE_HOSTNAME;
          } else {
            window.location.href = process.env.REACT_APP_INITIO_ENTERPRISE_HOSTNAME;
          }
          // window.location.href = process.env.REACT_APP_ENTERPRISE_HOSTNAME;
        } else if (portal === 'admin') {
          // window.location.href = process.env.REACT_APP_REDWOODSEED_ADMIN_HOSTNAME;
          if(isRedwoodSeed) {
            window.location.href = process.env.REACT_APP_REDWOODSEED_ADMIN_HOSTNAME;
          } else {
            window.location.href = process.env.REACT_APP_ADMIN_HOSTNAME;
          }
        } else {
          navigate('/portal-selection');
        }
      } catch {
        navigate('/login');
      }
    }

    validateAndRedirect();
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      className="Redirect"
    >
      <div className="spinner-container">
        <div className="dots-circle-spinner" />
      </div>
      <Typography variant="h6" sx={{ mt: 3, fontWeight: 500, color: '#333' }}>
        Redirecting to your portal...
      </Typography>
    </Box>
  );
}
